import {
  Button,
  Col,
  PageHeader,
  Row,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import CreateOrganizerModal from "./CreateOrganizerModal";
import { useForm } from "antd/lib/form/Form";
import UpdateOrganizerModal from "./UpdateOrganizerModal";
import apiOrganizer from "src/api/apiOrganizer";

const OrganizerList = () => {
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);

  const [activeRow, setActiveRow] = useState<any[]>([]);

  const [form] = useForm();
  const [formCreate] = useForm();
  const handleRow = (e: any) => {
    setActiveRow(e);
  };
  useEffect(() => {
    form.resetFields();
  }, [activeRow, form]);

  const { data, isLoading, isRefetching, refetch } = useQuery(
    "organizerlist",
    () => {
      return apiOrganizer.find();
    }
  );

  const columns = [
    {
      title: "#",
      key: "index",
      render: (_: any, __: any, index: number) => {
        return `${index + 1}`;
      },
    },
    {
      title: "Овог, Нэр",
      key: "index",
      dataIndex: ["user", "metadata"],
      render: (row: any) => {
        return <div>{row.lastName + " " + row.firstName}</div>;
      },
    },
    {
      title: "И-мэйл",
      key: "email",
      dataIndex: ["user", "metadata", "email"],
    },
    {
      title: "Хариуцаж буй спорт",
      key: "index",
      dataIndex: ["sportsObj"],
      render: (row: any) => {
        return (
          <div className="flex gap-1 max-w-[300px] flex-wrap">
            {row?.map((e: any) => {
              // console.log(e);
              return <Button key={e._id}>{e.name}</Button>;
            })}
          </div>
        );
        // return <p>{row.events}</p>;
      },
    },
    {
      title: "Үйлдэл",
      key: "index",
      render: (row: any, __: any, index: number) => {
        return (
          <>
            <Row align="middle" className="min-w-max">
              <Col className="mr-[1rem]">
                <Button
                  onClick={() => {
                    handleRow(row);
                    setUpdateModalVisible(true);
                  }}
                >
                  Дэлгэрэнгүй
                </Button>
              </Col>
              {/* <Col>
                <Popconfirm
                  title="Та тус зохион байгуулагчийг хасах гэж байна?"
                  onConfirm={async () => {
                    console.log(row);
                    const result = await apiOrganizer.delete(row.user._id);
                    if (result?.acknowledged) {
                      notification.success({
                        message: "Амжилттай устгагдлаа.",
                      });
                    } else {
                      notification.error({ message: result?.error });
                    }
                    refetch();
                  }}
                  cancelText="Цуцлах"
                  okText="Устгах"
                  okButtonProps={{ danger: true }}
                >
                  <Button danger type="primary">
                    Устгах
                  </Button>
                </Popconfirm>
              </Col> */}
            </Row>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Row align="middle" justify="space-between">
        <Col>
          <Row align="middle">
            <PageHeader title={"Зохион байгуулагчдын жагсаалт"} />
          </Row>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => {
              setCreateModalVisible(true);
            }}
          >
            Шинээр үүсгэх
          </Button>
        </Col>
      </Row>

      <>
        <Table
          rowKey="_id"
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          dataSource={data?.data}
          pagination={{
            total: data?.pagination?.total,
          }}
        />

        {/* {!isLoading && (
          <Row justify="center">
            <Pagination
              style={{ marginTop: 50 }}
              total={Math.ceil(data?.data?.total)}
              showSizeChanger
              showTotal={(total) => (
                <div style={{ alignItems: "middle", display: "flex" }}>
                  {`Нийт ${total} төлбөр`}
                </div>
              )}
              onChange={(page, pageSize) => {
                setLimit(pageSize);
                setOffset(page);
                refetch();
              }}
            />
          </Row>
        )} */}

        <CreateOrganizerModal
          isVisible={createModalVisible}
          form={formCreate}
          refetchList={refetch}
          onCancel={() => {
            setCreateModalVisible(false);
            formCreate.resetFields();
          }}
        />

        {updateModalVisible && (
          <UpdateOrganizerModal
            data={activeRow}
            form={form}
            refetchList={refetch}
            isVisible={updateModalVisible}
            onCancel={() => {
              setUpdateModalVisible(false);
              form.resetFields();
            }}
          />
        )}
      </>
    </>
  );
};

export default OrganizerList;
